<template>
<div>
    <div
      v-if="items.length"
      :class="`${classNames} d-flex align-items-start flex-lg-column flex-md-column`"
    >
      <div class="expand-text">
        {{ items[0][columns[0]] }}
      </div>
      <div class="expand-btn" tabindex="0" id="expandItemsButton">
        <span
          v-if="items.length > 1"
          class="clickable color-blue"
        >
          <i class="fas fa-plus-circle" />
        </span>
      </div>
    </div>
    <b-popover ref="listPopover" v-if="items.length > 1" target="expandItemsButton" triggers="focus">
      <v-client-table :data="items" :columns="columns" :options="options" @pagination="resize"/>
    </b-popover>
  </div>
</template>
<script>
export default {
  name: "ListTablePopover",
  props: ["items", "columns", "classNames"],
  methods: {
    resize () {
      this.$refs.listPopover.$forceUpdate()
    },
  },
  data () {
    return {
      options: {
        skin: "table table-striped modal-table",
      },
    }
  }
}
</script>
